import React from 'react';

import { useTranslation } from 'react-i18next';
import { Icon } from '../../primitives';


export default function LoginButton() {
    const { t } = useTranslation('mainLayout');
    const svgAccount =
        'M13.979,10.587a8.157,8.157,0,0,0-3.112-1.952,4.734,4.734,0,1,0-5.357,0A8.2,8.2,0,0,0,0,16.377H1.279a6.909,6.909,0,1,1,13.818,0h1.279A8.135,8.135,0,0,0,13.979,10.587Zm-5.79-2.4a3.455,3.455,0,1,1,3.455-3.455A3.458,3.458,0,0,1,8.188,8.188Z';

    return (
        <div className='user'>
            <Icon d={svgAccount} size='20' />
            <span className='accountText'>{t('login')}</span>
        </div>
    );
}
